import React, {
  useContext,
  useState,
  useEffect,
  useRef,
  Fragment,
} from "react";
import PropTypes from "prop-types";
import { CredsContext } from "./Contexts";
import Tools from "./JNSTools";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import List from "@mui/material/List";
import ListItem from "@mui/material/List";
import ListItemText from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import Collapse from "@mui/material/Collapse";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import ChangeLogHeader from "./ChangeLogHeader";
import "./styles/ChangeLog.css";

function ChangeLogByNameComponent(props) {
  const nameArray = useRef(props.changeLog);
  const open = props.open;
  const [dirty, isDirty] = useState(false);
  /*const selectedEntities = JSON.parse(
    sessionStorage.getItem("changeLogCheckboxSettings"),
  );*/

  let settings;
  const settingsRaw = localStorage.getItem("oadaSettings");
  if (settingsRaw) {
    settings = JSON.parse(settingsRaw);
  }

  //const selectedEntities = settings.changeLogCheckboxSettings;
  const taskCheckbox = settings.changeLogCheckboxSettingsTasks;
  const reqCheckbox = settings.changeLogCheckboxSettingsReqs;
  const issueCheckbox = settings.changeLogCheckboxSettingsIssues;

  function expandCollapse(event) {
    Object.keys(open).forEach((key) => {
      open[key] = event.target.textContent == "Expand All" ? true : false;
    });
    isDirty(!dirty);
  }

  const displayPage =
    nameArray.current.length > 0 ? (
      <Box width="100%">
        <Box
          className="logsBox"
          width="100%"
          border="solid 1px"
          padding="0px 10px"
        >
          <List component="nav">
            <ListItem>
              <ListItemText>
                <span
                  className="expandCollapse"
                  value={true}
                  onClick={expandCollapse}
                >
                  Expand All
                </span>
                &nbsp;&nbsp;&nbsp;&nbsp;
                <span
                  className="expandCollapse"
                  value={false}
                  onClick={expandCollapse}
                >
                  Collapse All
                </span>
              </ListItemText>
            </ListItem>
            {nameArray.current.map((nameElem, nameIndex) =>
              (taskCheckbox && nameElem.entityType == "task") ||
              (issueCheckbox && nameElem.entityType == "issue") ||
              (reqCheckbox && nameElem.entityType == "requirement") ? (
                <Fragment key={"name" + nameIndex}>
                  <ListItemButton
                    className="groupButton"
                    id={"n" + nameIndex}
                    onClick={props.handleClick}
                  >
                    <ListItemText
                      className="nameGroup"
                      data-entitytype={nameElem.entityType}
                    >
                      {nameElem.entityName.indexOf("|") >= 0
                        ? nameElem.entityName.substring(
                            nameElem.entityName.indexOf("|") + 1,
                          ) +
                          ": " +
                          nameElem.entityName.substring(
                            0,
                            nameElem.entityName.indexOf("|"),
                          )
                        : nameElem.entityName}
                    </ListItemText>
                    {open["n" + nameIndex] ? <ExpandLess /> : <ExpandMore />}
                  </ListItemButton>
                  <Collapse
                    in={open["n" + nameIndex]}
                    timeout="auto"
                    unmountOnExit
                  >
                    <List component="div">
                      {nameElem.messages.map((messageElem, messageIndex) => (
                        <Fragment key={"message" + messageIndex}>
                          <ListItemText sx={{ pl: 15 }} className="logMessage">
                            {messageElem.substring(
                              0,
                              messageElem.indexOf(":o:"),
                            )}
                            &nbsp;&nbsp;
                            <span className="timestamp">
                              {messageElem.substring(
                                messageElem.indexOf(":o:") + 4,
                              )}
                            </span>
                          </ListItemText>
                        </Fragment>
                      ))}
                    </List>
                  </Collapse>
                </Fragment>
              ) : (
                <Fragment key={"name" + nameIndex}></Fragment>
              ),
            )}
          </List>
        </Box>
      </Box>
    ) : (
      ""
    );

  return displayPage;
}

export default ChangeLogByNameComponent;

ChangeLogByNameComponent.propTypes = {
  changeLog: PropTypes.array,
  projectname: PropTypes.string,
  handleClick: PropTypes.func,
  handleGroupByChange: PropTypes.func,
  handleCheckboxChange: PropTypes.func,
  open: PropTypes.object,
};
